export default class QuestionsScoreStage {
    constructor() {
        this.question = null;
        this.answer = null;
    }

    setAnswer(question, answer) {
        this.question = question;
        this.answer = answer;
    }

    getScore() {
        const scoresMap = this.question.scores;

        if (!scoresMap) {
            return null;
        }

        let score = 0;

        this.answer.every(answer => {
            const answerScore = scoresMap[answer.index];
            score = answerScore ? score + answerScore : null;
            return typeof answerScore === 'number';
        });

        return score;
    }

    getFeedback() {
        return null;
    }
}
